import { labelsSelector } from "@client/selectors";
import { I18nContextProvider } from "@common/contexts/I18n";
import { type WithChildren } from "@common/declarations";
import * as React from "react";
import { useSelector } from "react-redux";

type I18nLabelProviderProps = WithChildren & {
  category: string;
};
export const I18nLabelProvider = (props: I18nLabelProviderProps) => {
  const labels = useSelector(labelsSelector);

  const i18n = React.useMemo(() => ({ ...labels["Global"], ...labels[props.category] }), [labels, props.category]);
  return <I18nContextProvider i18n={i18n}>{props.children}</I18nContextProvider>;
};
